module.exports = __webpack_public_path__ + "static/media/eti.fa77e4ea.png";